import { Dispatch } from 'redux'
import { ActionType, LogisticsAction } from './actionTypes'
import { Driver, Roadmap, Vehicle, DeliveryRoadmap } from './types'

export const updateDrivers = (drivers: Driver[]) => {
    return (dispatch: Dispatch<LogisticsAction>) => {
        dispatch({
            type: ActionType.UPDATE_DRIVERS,
            payload: drivers
        })
    }
}

export const removeDrivers = (ids: string[]) => {
    return (dispatch: Dispatch<LogisticsAction>) => {
        dispatch({
            type: ActionType.REMOVE_DRIVERS,
            payload: ids
        })
    }
}

export const updateVehicles = (vehicles: Vehicle[]) => {
    return (dispatch: Dispatch<LogisticsAction>) => {
        dispatch({
            type: ActionType.UPDATE_VEHICLES,
            payload: vehicles
        })
    }
}

export const removeVehicles = (ids: string[]) => {
    return (dispatch: Dispatch<LogisticsAction>) => {
        dispatch({
            type: ActionType.REMOVE_VEHICLES,
            payload: ids
        })
    }
}

export const updateRoadmaps = (roadmaps: Roadmap[]) => {
    return (dispatch: Dispatch<LogisticsAction>) => {
        dispatch({
            type: ActionType.UPDATE_ROADMAPS,
            payload: roadmaps
        })
    }
}

export const removeRoadmaps = (ids: string[]) => {
    return (dispatch: Dispatch<LogisticsAction>) => {
        dispatch({
            type: ActionType.REMOVE_ROADMAPS,
            payload: ids
        })
    }
}

export const updateDeliveryRoadmaps = (deliveryRoadmaps: DeliveryRoadmap[]) => {
    return (dispatch: Dispatch<LogisticsAction>) => {
        dispatch({
            type: ActionType.UPDATE_DELIVERY_ROADMAPS,
            payload: deliveryRoadmaps
        })
    }
}

export const removeDeliveryRoadmaps = (ids: string[]) => {
    return (dispatch: Dispatch<LogisticsAction>) => {
        dispatch({
            type: ActionType.REMOVE_DELIVERY_ROADMAPS,
            payload: ids
        })
    }
}
